import React from 'react';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppTheme } from './ThemeProvider';

const ThemeToggle: React.FC = () => {
  const { mode, toggleMode } = useAppTheme();

  return (
    <IconButton color="inherit" onClick={toggleMode} title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      <FontAwesomeIcon icon={mode === 'dark' ? 'sun' : 'moon'} />
    </IconButton>
  );
};

export default ThemeToggle;
